import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '='
    },
    template: `
        <form-wrapper form="vm.form">
            <form-row error="vm.form.errors.metaFieldI18ns[vm.defaultLanguage].name || vm.form.errors.metaFieldI18ns">
                <label class="label">{{ 'metaField.Meta field name' | translate }} *</label>
                <div class="items">
                    <input ng-disabled="!vm.QuestionService.canManageQuestionRelatedData()" ng-model="vm.form.model.metaFieldI18ns[vm.defaultLanguage].name" type="text" class="form-control">
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <form-row error="vm.form.errors.type">
              <label class="label">{{ 'metaField.Type' | translate }} *</label>
              <div class="items">
                <select class="form-control"
                        ng-disabled="!vm.QuestionService.canManageQuestionRelatedData()"
                        ng-model="vm.form.model.type"
                        ng-options="vm.FORMS_META_FIELD_TYPE_ENUM.KEYS[item] as vm.FORMS_META_FIELD_TYPE_ENUM.LABELS[item]
                                    for item in vm.FORMS_META_FIELD_TYPE_ENUM.KEYS
                                    track by vm.FORMS_META_FIELD_TYPE_ENUM.KEYS[item]">
                  <option value=""></option>
                </select>
                <form-row-error></form-row-error>
              </div>
            </form-row>
            <div ng-if="vm.form.model.type== vm.FORMS_META_FIELD_TYPE_ENUM.KEYS.SELECT">
            <form-row error="vm.form.errors.metaFieldValuesI18ns">
				<span class="label">{{ 'metaField.Values' | translate }} *</span>
				<div class="items">
					<ul class="multirow">
						<li ng-repeat="languageModel in vm.form.model.metaFieldValuesI18ns[vm.defaultLanguage]">
						    <input ng-disabled="!vm.QuestionService.canManageQuestionRelatedData()" class="form-control"
						      value="{{ languageModel.value }}"
						      ng-model="languageModel.value">
						    <a
						        ng-if="vm.QuestionService.canManageQuestionRelatedData() && vm.form.model.metaFieldValuesI18ns[vm.defaultLanguage].length > 1"
						        class="btn delete"
						        ng-click="vm.removeValueRow($index)"
						     >
						        {{ 'general.Delete' | translate }}
						    </a>
						    <a ng-if="vm.QuestionService.canManageQuestionRelatedData() && $last" class="btn add" ng-click="vm.addValueRow()">{{ 'metaField.Add' | translate }}</a>
						</li>
					</ul>
					<form-row-error></form-row-error>
				</div>
			</form-row>
		</div>
        </form-wrapper>
    </form>
    `
})
export default class {
    constructor (lodash, MetaFieldGroupResource, FORMS_META_FIELD_TYPE_ENUM, TokenService, QuestionService) {
        this.FORMS_META_FIELD_TYPE_ENUM = FORMS_META_FIELD_TYPE_ENUM;
        this.metaFieldGroups = MetaFieldGroupResource.query({ pageSize: 0 });
        this.defaultLanguage = TokenService.getCompanyLanguage();
        this.lodash = lodash;
        this.QuestionService = QuestionService;

        if (this.form.model.metaFieldGroupId) {
            this.form.model.metaFieldGroupId = `${this.form.model.metaFieldGroupId}`;
        }
    }

    $onInit () {
        if (!this.form.model.metaFieldValuesI18ns) {
            this.form.model.metaFieldValuesI18ns = {};
        }

        this.form.model.metaFieldValuesI18ns = this.lodash.reduce(this.form.model.metaFieldValuesI18ns, (origin, item) => {
            if (!origin[item.language]) {
                origin[item.language] = [];
            }
            origin[item.language].push(item);
            return origin;
        }, {});

        if (!this.form.model.metaFieldValuesI18ns || !this.form.model.metaFieldValuesI18ns[this.defaultLanguage]) {
            this.form.model.metaFieldValuesI18ns[this.defaultLanguage] = [];
            this.addValueRow();
        }
    }

    addValueRow () {
        this.form.model.metaFieldValuesI18ns[this.defaultLanguage].push({ value: null });
    }

    removeValueRow (index) {
        this.form.model.metaFieldValuesI18ns[this.defaultLanguage].splice(index, 1);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/settings/meta/field/generaldata/index.js